/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "schoolboosterapirest",
            "endpoint": "https://ym6qst9z3c.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://zqilmkkahfd7xkwqisuactd5hu.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-1:f7464098-957b-4b81-ae9c-6ce3bdb01421",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_wgYcd2oSX",
    "aws_user_pools_web_client_id": "6l1u5hha3o0pi93e7ltdka732e",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "schoolboostertsfront8150858f70ed42ef84dd37aa444154912-prod",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
